
import BaseCom from "../../../../components/BaseCom";
import Icon from "../../../../components/Icon";
import L from "../../../../components/Lang";
import AppActions from "../../../../components/Solusek/AppActions";
import { withParamsAndNavigate } from "../../../../components/WithParamsAndNavigate";
import CodeEditor from "../../../../components/Solusek/CodeEditor";
import { qreq } from "../../../../shared/qrequest";
import FormInputV2 from "../../../../components/FormInputV2";
import { Pop } from "../../../../components/PopModal";
import { Modal } from "react-bootstrap";

class AnalyzerEdit extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            info: {
                sourceCode: ''
            }
        };
    }

    async componentDidMount() {
        await this.load();
    }

    load = async() => {
        if(this.props.params.id) {
            let j = await this.apiGet('/api/internal/analyzer/item/' + this.props.params.id);
            if(j.item)
                this.setState({ info: j.item, loaded: true });
            else {
                this.alert(j.errorMessage);
                this.goBack();
            }
        }
        else
            this.setState({ loaded: true });
    }

    submit = async (e) => {
        e?.preventDefault();

        try {
            let originalId = this.state.info.id;
            let j = await qreq.postAsync('/api/internal/analyzer/save', this.state.info);
            if(j.errorCode === 0) {
                this.success('Saved!');
                this.setState({ info: j.item });
                this.rehash();
                if(!originalId)
                    this.props.navigate(j.item.id);
            }
            else
                this.alert(j.errorMessage);
        }
        catch(e) {
            this.unkownErrorCallback(e);
        }
    }

    verify = async () => {
          try {
           let j = await qreq.postAsync('/api/internal/analyzer/verify', this.state.info);
            if(j.errorCode === 0) {
                this.success('Valid!');
            }
            else
                this.showVerifyError(j.errorMessage);
        }
        catch(e) {
            this.unkownErrorCallback(e);
        }
    }

    showVerifyError = (msg) => {
        let newMsg = [];
        let p = msg.split('\n');
        p.forEach(i => {
            newMsg.push(<p>{i}</p>);
        });
        this.setState({ verifyError: newMsg });
    }

    change = () => {
        this.setState({ info: {...this.state.info}});
    }

    back = () => {
        if(this.state.touched) {
            Pop.showConfirm('Changes will be lost', 'Do you wish to continue?', () => {
                this.goBack();
            });
        }
        else
            this.goBack();
    }

    render() {
        return (
            <div className="container-fluid">
                <h1><L>Analyzer</L></h1>

                <Modal show={this.state.verifyError} onHide={() => this.setState({ verifyError: null })} size="xl">
                    <Modal.Header>
                        <Modal.Title>Errors</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>{this.state.verifyError}</div>
                    </Modal.Body>
                </Modal>

                <form onSubmit={this.submit}>
                    <FormInputV2 model={this.state.info} name="name" onChange={this.change} placeholder="Analyzer Name" required />
                    
                    {this.state.loaded && <CodeEditor
                        language="vb"
                        value={this.state.info.sourceCode}
                        height="80vh"
                        onChange={(v) => this.setState({ info: { ...this.state.info, sourceCode: v }, touched: true })}
                        hash={this.state.hash}
                    />}

                    <AppActions>
                        <div>
                            <button type="button" className="btn btn-lg btn-primary" onClick={this.verify}>
                                <Icon icon="faCode" /> <L>Verify</L>
                            </button>
                            <button type="submit" className="btn btn-lg btn-success">
                                <Icon icon="faSave" /> <L>Save</L>
                            </button>
                            <button type="button" className="btn btn-lg btn-secondary" onClick={this.back}>
                                <Icon icon="faCancel" /> <L>Go Back</L>
                            </button>
                        </div>
                    </AppActions>
                </form>
            </div>
        );
    }
}

export default withParamsAndNavigate(AnalyzerEdit);